import { UserProfile } from '@clerk/clerk-react';

interface UserProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function UserProfileModal({ isOpen, onClose }: UserProfileModalProps) {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 transition-opacity"
        onClick={onClose}
        aria-hidden="true"
      />
      
      {/* Modal Container - Properly sized for UserProfile */}
      <div
        className="relative min-h-screen flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div
          className="relative bg-surface rounded-xl shadow-lg w-full max-w-4xl max-h-[90vh] overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 p-2 rounded-md hover:bg-surface-alt transition-colors bg-surface/80 backdrop-blur-sm"
            aria-label="Close modal"
          >
            <svg className="w-5 h-5 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          {/* UserProfile Component - Container query wrapper */}
          <div className="overflow-y-auto max-h-[90vh] user-profile-container">
            <UserProfile
              appearance={{
                elements: {
                  card: {
                    boxShadow: 'none',
                    border: '0',
                    borderRadius: '0',
                    padding: '0',
                    width: '100%',
                  },
                  scrollBox: { maxHeight: 'none' },
                  pageScrollBox: { maxHeight: 'none' },
                  page: {
                    display: 'flex !important',
                    minHeight: '500px',
                    gap: '0',
                  },
                  navbar: {
                    width: '200px !important',
                    minWidth: '200px !important',
                    flexShrink: '0 !important',
                    borderRight: '1px solid #e0e0e0',
                    backgroundColor: '#ffffff !important',
                  },
                  profileSection: {
                    flex: '1 !important',
                    padding: '24px !important',
                    maxWidth: 'none !important',
                  },
                  profileSectionContent: {
                    marginTop: '16px !important',
                    paddingTop: '8px !important',
                  },
                  profileSectionHeader: {
                    marginBottom: '12px !important',
                    paddingBottom: '4px !important',
                    display: 'block !important',
                    width: '100% !important',
                  },
                },
              }}
              routing="hash"
            />
          </div>
        </div>
      </div>
    </div>
  );
}